import {
    Autocomplete,
    FormControl,
    InputLabel,
    Select,
    TextField,
    Grid,
    MenuItem
  } from '@mui/material'
  import React from 'react'
  
  const Cough = ({ moduleValues, setModuleValues }) => (
    <Grid item xs={12} lg={4}>
       <FormControl fullWidth>
        <InputLabel>Cough</InputLabel>
        <Select
          value={moduleValues?.['Cough'] ?? ''}
          onChange={(e) =>setModuleValues(prev => ({...prev, ['Cough']: e.target.value}))
          }
          label="Cough"
        >
          <MenuItem value="No Cough">No Cough</MenuItem>
          <MenuItem value="Dry Cough">Dry Cough</MenuItem>
          <MenuItem value="Productive Cough">Productive Cough</MenuItem>
        </Select>
      </FormControl>
    </Grid>
  )
  
  export default Cough
  